// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.show {
  display: block;
  background: rgba(0, 0, 0, 0.5);
}

.modal-body img {
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/bootstap-image-modal/bootstap-image-modal.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".modal.show {\r\n  display: block;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.modal-body img {\r\n  object-fit: contain;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
